import { createAction } from '@lingoda/core';

export default createAction<string>('notifications/REMOVE_NOTIFICATION');
